// de strings for messages/pricing.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const pricing: Dict = {
  "pricing.promo": "Dein erster Monat ab {price}",
  "pricing.title": "Erstelle Cover mit jeder Stimme",
  "pricing.subtitle":
    "Unbegrenzt Cover, Downloads und alle über 93.000 Stimmen. Jederzeit kündbar.",
  "pricing.trialLinkInvalid":
    "Dieser Link zum kostenlosen Testen gehört zu einem anderen Konto oder ist abgelaufen. Du siehst den normalen Checkout.",

  "pricing.basic.subtitle": "Zum Erstellen von Covern",
  "pricing.creator.subtitle": "Für Videos und eigene Stimmen",
  "pricing.power.subtitle": "Für Vielnutzer und Entwickler",
  "pricing.badge.popular": "Am beliebtesten",

  "pricing.feature.unlimitedCovers": "Unbegrenzt Cover",
  "pricing.feature.download": "Cover, Gesang und Musik herunterladen",
  "pricing.feature.library": "Die komplette Stimmen-Bibliothek",
  "pricing.feature.tts": "Text-to-Speech",
  "pricing.feature.duets": "Duette",
  "pricing.feature.credits": "Credits verfallen nie",
  "pricing.feature.train": "Unbegrenzt Stimmen trainieren",
  "pricing.feature.videos": "Teilbare Videos: Marble Run und Lyrics",
  "pricing.feature.coins50": "50 Video-Coins jeden Monat",
  "pricing.feature.priority": "Bevorzugte Verarbeitung, 250 pro 12 Stunden",
  "pricing.feature.coinsUnlimited": "Unbegrenzt Video-Coins",
  "pricing.feature.api": "$25 API-Guthaben jeden Monat",

  "pricing.compareAll": "Alles vergleichen",
  "pricing.trust.cancel": "Jederzeit kündbar, deine Werke bleiben",
  "pricing.trust.stripe": "Sicherer Checkout mit Stripe",
  "pricing.trust.currency": "Preise in deiner Währung",

  "pricing.compare.title": "Pläne vergleichen",
  "pricing.compare.noPlan": "Kein Plan",
  "pricing.compare.browse": "Alle Stimmen entdecken und anhören",
  "pricing.compare.covers": "Cover",
  "pricing.compare.downloads": "Downloads",
  "pricing.compare.ttsDuets": "Text-to-Speech und Duette",
  "pricing.compare.song": "Song mit KI generieren",
  "pricing.compare.train": "Eigene Stimmen trainieren",
  "pricing.compare.videos": "Videos (Marble Run, Lyrics)",
  "pricing.compare.priority": "Bevorzugte Verarbeitung",
  "pricing.compare.api": "API-Guthaben",
  "pricing.compare.unlimited": "Unbegrenzt",
  "pricing.compare.coins50": "50 Coins pro Monat",
  "pricing.compare.priorityLimit": "250 pro 12 Stunden",
  "pricing.compare.apiAmount": "$25 pro Monat",

  "pricing.faq.title": "Fragen",
  "pricing.faq.noPlan.q": "Was kann ich ohne Plan machen?",
  "pricing.faq.noPlan.a":
    "Du kannst alle Stimmen auf Jammable entdecken und anhören. Für Cover, Downloads, Text-to-Speech und Duette brauchst du einen Plan.",
  "pricing.faq.basic.q": "Was ist im Basic-Plan enthalten?",
  "pricing.faq.basic.a":
    "Der Basic-Plan enthält unbegrenzt Cover, Downloads, Zugriff auf die komplette Stimmen-Bibliothek von Jammable, Text-to-Speech und Duette, und deine Credits verfallen nie.",
  "pricing.faq.creator.q": "Was unterscheidet Creator von Basic?",
  "pricing.faq.creator.a":
    "Creator bietet alles aus Basic und dazu unbegrenztes Training eigener Stimmen, teilbare Videos und 50 Marble-Run-Coins pro Monat.",
  "pricing.faq.power.q": "Was macht den Power-Plan besonders?",
  "pricing.faq.power.a":
    "Power enthält alles aus Creator, dazu bevorzugte Verarbeitung (250 pro 12 Std.), unbegrenzt Marble-Run-Coins und jeden Monat $25 API-Guthaben für professionelle Creator.",
  "pricing.faq.cancel.q": "Kann ich mein Abo jederzeit kündigen?",
  "pricing.faq.cancel.a":
    "Ja, du kannst jederzeit kündigen. Deine Vorteile bleiben bis zum Ende des Abrechnungszeitraums aktiv.",
  "pricing.faq.change.q": "Kann ich up- oder downgraden?",
  "pricing.faq.change.a":
    "Klar. Wechsle jederzeit nach oben oder unten, deine Vorteile passen sich entsprechend an.",

  "pricing.card.perYear": "pro Jahr, ca. {price} pro Monat",
  "pricing.card.firstMonthThen": "im ersten Monat, danach {price} pro Monat",
  "pricing.card.perMonth": "pro Monat",
  "pricing.card.startFor": "Starten für {price}",
  "pricing.card.everythingIn": "Alles aus {plan}, plus",
  "pricing.cta.get": "{plan} holen",
  "pricing.cta.yourPlan": "Dein Plan",
  "pricing.cta.manage": "Plan verwalten",
  "pricing.cta.upgradeTo": "Upgrade auf {plan}",
  "pricing.cta.updated": "Dein Abo wurde aktualisiert!",
  "pricing.error.generic":
    "Etwas ist schiefgelaufen. Bitte wende dich an den Support!",
  "pricing.seo.title": "Preise | Jammable",
  "pricing.seo.description":
    "Jammable-Pläne für KI-Cover mit jeder Stimme: unbegrenzt Cover, Downloads und über 93.000 Stimmen. Preise in deiner Währung, jederzeit kündbar.",
};

export default pricing;
